import { useCallback, useEffect, useMemo, useState } from 'react';
import theme from '../../theme';
const themeBreakpoints = theme.breakpoints;
const useCurrentBreakpoint = () => {
    const [breakpoint, setBreakpoint] = useState('md');
    const updateBreakpoint = useCallback(() => {
        const width = window.innerWidth;
        if (width >= themeBreakpoints.ultra)
            return setBreakpoint('ultra');
        if (width >= themeBreakpoints.wide)
            return setBreakpoint('wide');
        if (width >= themeBreakpoints.xxl)
            return setBreakpoint('xxl');
        if (width >= themeBreakpoints.xl)
            return setBreakpoint('xl');
        if (width >= themeBreakpoints.l)
            return setBreakpoint('l');
        if (width >= themeBreakpoints.md)
            return setBreakpoint('md');
        if (width >= themeBreakpoints.tablet)
            return setBreakpoint('tablet');
        if (width >= themeBreakpoints.mobile)
            return setBreakpoint('mobile');
        setBreakpoint('mobile');
    }, []);
    useEffect(() => {
        updateBreakpoint();
        window.addEventListener('resize', updateBreakpoint);
        return () => window.removeEventListener('resize', updateBreakpoint);
    }, [updateBreakpoint]);
    return useMemo(() => breakpoint, [breakpoint]);
};
export default useCurrentBreakpoint;
